import React from 'react';
import PostcardItem from '../PostcardComponent';
import { getPostcards } from '../../api/client';
import Map from '../MapComponent';
import './index.css';

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

class PostcardList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      postcards: [],
      markers: [],
      isDialogOpen: false,
      id: ''
    };
  }
  componentDidMount() {
    getPostcards(this);
  }

  handleClick = e => {
    if (this.state.postcards[e]) this.setState({ isDialogOpen: true, id: e });
  };

  handleClose = () => {
    this.setState({ isDialogOpen: false });
  };

  handleMarkerClick = e => {
    const id = e.target.options.id;
    this.setState({ isDialogOpen: true, id: id });
  };

  handleDelete = id => {
    this.setState({ postcards: [], markers: [] });
    getPostcards(this);
  };

    openDialog = () => {
        const id = this.state.id
        return (this.state.isDialogOpen && this.state.postcards[id]
            ?
            <Dialog
                onClose={() => { this.handleClose() }}
                aria-labelledby="DialogTitle"
                open={this.state.isDialogOpen}
                maxWidth='lg'
                fullWidth={true}
            >
                <DialogTitle id="DialogTitle" onClose={() => { this.handleClose() }}>
                    <div className="title-label">
                        Postcard
                    </div>
                    <IconButton className="close-button" onClick={() => { this.handleClose() }} aria-label="Close">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <PostcardItem
                        id={this.id}
                        title={this.state.postcards[id].title}
                        description={this.state.postcards[id].description}
                        author={this.state.postcards[id].author}
                        image={this.state.postcards[id].image}
                        location={this.state.postcards[id].location}
                        date={this.state.postcards[id].date}
                        className="postcard-item-detailed"
                        handleDelete={this.handleDelete}
                    />
                </DialogContent>
            </Dialog>
            : null)
    }

  render() {
    return this.state.postcards && this.state.markers ? (
      <div>
        <Map
          markers={this.state.markers}
          onClick={e => this.handleMarkerClick(e)}
        />
        <ul id="Sidebar" className="postcardList">
          {this.state.postcards.map((post, idx) => (
            <li
              key={post.id}
              className="listElement"
              onClick={() => this.handleClick(idx)}
            >
              <PostcardItem
                id={post.id}
                title={post.title}
                description={post.description}
                author={post.author}
                image={post.image}
                location={post.location}
                date={post.date}
                className="postcard-item"
                handleDelete={this.handleDelete}
              />
            </li>
          ))}
        </ul>
        {this.openDialog()}
      </div>
    ) : null;
  }
}

export default PostcardList;
